<div class="block-one">
  <div class="app-title">
    @if (brandImageUrl) {
      <img [src]="brandImageUrl" alt="Brand Image" />
    }

    @if (!currentFloorplan || !currentFloorplan.IsInventoryHome) {
      @if (secondaryBrandImageUrl) {
        <img [src]="secondaryBrandImageUrl" class="secondary" alt="Brand Image" />
      }
      @if (!secondaryBrandImageUrl && brandingHtml) {
        <span [innerHtml]="brandingHtml"></span>
      }
    }

    @if (currentFloorplan?.IsInventoryHome) {
      @if (ihBrandImageUrl) {
        <img [src]="ihBrandImageUrl" class="secondary" alt="IH Brand Image" />
      }
      @if (!ihBrandImageUrl) {
        <span>Your <b class="inventory-home">{{theme.inventoryHomeLabel}}</b></span>
      }
    }
  </div>
  <button class="hc-btn primary clear-session-btn" (click)="clearSessionAndGoBackToStart()" aria-label="Clear Session">
    <ml-icon name="reset_arrow"></ml-icon>
    <span class="label">Clear Session</span>
  </button>
  <button class="hc-btn primary saved-builds-btn" (click)="handleOpenSavedBuilds()" aria-label="Saved Builds">
    <ml-icon name="user"></ml-icon>
    <span class="label">Saved Items</span>
  </button>

  <button class="close-btn">
    <ml-icon name="x"></ml-icon>
  </button>
</div>

<div class="block-two">
  <div class="fp-title-container">
    <ml-icon name="floorplan"></ml-icon>

    <div class="text-container">
      <p class="subtitle">
        Selected {{theme.fpLabel}}
      </p>
      <h3 class="fp-name">
        <div class="bubble" [class.warning]="!currentFloorplan">
          @if (currentFloorplan) {
            <ml-icon name="check"></ml-icon>
          }
          @if (!currentFloorplan) {
            <ml-icon name="exclamation"></ml-icon>
          }
        </div>
        <button class="hc-btn underline" (click)="handleFloorPlanSelect()">
          @if (currentFloorplan) {
            <span>{{currentFloorplan.Name}}</span>
          }
          @if (!currentFloorplan) {
            <span>Select a {{theme.fpLabel}}</span>
          }
        </button>
      </h3>
    </div>
  </div>
  <button class="hc-btn primary clear-session-btn" (click)="clearSessionAndGoBackToStart()" aria-label="Clear Session">
    <ml-icon name="reset_arrow"></ml-icon>
    <span class="label">Clear Session</span>
  </button>
  <button class="hc-btn primary saved-builds-btn" (click)="handleOpenSavedBuilds()" aria-label="Saved Builds">
    <ml-icon name="user"></ml-icon>
    <span class="label">Saved Items</span>
  </button>
</div>